import { ReactNode } from "react";
import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import Modal from "components/ui/modal/Modal";
import UIcon from "lib/icons/untitled_ui/UIcon";

type AiChatModalProps = {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
};

export default function AiChatModal({ isOpen, onClose, children }: AiChatModalProps) {
  const theme = useTheme();

  return (
    <Modal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      backgroundColor={theme.colors.sysBackgroundAlternative}
      showCloseButton={false}
      maxWidth="90vw"
    >
      <CloseModalButton onClick={onClose} aria-label="Close">
        <UIcon icon="xClose" size={16} color="inherit" />
      </CloseModalButton>
      <AiChatContainer>{children}</AiChatContainer>
    </Modal>
  );
}

const CloseModalButton = styled.button(({ theme }) => ({
  position: "absolute",
  top: 28,
  right: 28,
  padding: "2px 4px",
  color: theme.colors.sysTextSecondary,
  borderRadius: 4,
  backgroundColor: "transparent",
  border: `1px solid ${theme.colors.sysBorderDecorative}`,
  cursor: "pointer",
  zIndex: 2,
  "&:hover": {
    color: theme.colors.sysTextBlack,
  },
}));

const AiChatContainer = styled.div({
  height: "90vh",
});
